import React, { Component } from "react";
import { Button, ListGroup, Form, Row, Col } from "react-bootstrap";
import Select from 'react-select';
import { LinkContainer } from "react-router-bootstrap";
import "containers/common/List.css";
import { createColumnHelper } from "@tanstack/react-table";
import { GenericTable } from "components/GenericTable";
import { PAGE_SIZES } from "utils/pageSizeConfig";
import { createElementIdFactory, createReusableTableElementIds } from "utils/elementIds";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SLMAgencyModal from "containers/slm/shared/SLMAgencyModal";
import "containers/slm/lease/SLMLeaseDetail.css";

const normalizeEntityLinkTableData = (data) => {
    const nextData = Array.isArray(data) ? [...data] : [];

    if (nextData.length > 0) {
        if (nextData.some((item) => Object.prototype.hasOwnProperty.call(item || {}, "name"))) {
            nextData.sort((a, b) => {
                if ((a?.name ?? "") < (b?.name ?? "")) {
                    return -1;
                }
                if ((a?.name ?? "") > (b?.name ?? "")) {
                    return 1;
                }
                return 0;
            });
        } else if (nextData.some((item) => Object.prototype.hasOwnProperty.call(item || {}, "first_name"))) {
            nextData.sort((a, b) => {
                if ((a?.first_name ?? "") < (b?.first_name ?? "")) {
                    return -1;
                }
                if ((a?.first_name ?? "") > (b?.first_name ?? "")) {
                    return 1;
                }
                return 0;
            });
        }
    }

    return nextData;
};

export default class SLMEntityLinkList extends Component {
    constructor(props) {
        super(props);
        this.createId = createElementIdFactory("slm-entity-link-list");
        this.tableElementIds = createReusableTableElementIds(this.createId, "main");
        this.agentOptionsByOrgId = new Map();

        this.state = {
            searching: false,
            isLoading: true,
            agencies: [],
            filter: {},
            showAgentDialog: false,
            showAlert: false,
            editedAgencies: [],
            dataSet: "entityLinks",
            dataRecord: "entityLink",
            dataSetPrimaryKey: "entity_link_id",
            newRecordIndex: 0,
            agencySearchString: null,
            agencyInterstateFlag: true,
            selectedAgency: null,
            selectedAgent: null,
            agencyOptions: [],
            agentOptions: [],
            agencyMenuIsOpen: false,
            entity_org_id: null,
            agency_name: null,
            agency_phone: null,
            agency_phone_ext: null,
            agency_phone_no: null,
            agency_suburb: null,
            agency_state: null,
            agency_postcode: null,
            entity_person_id: null,
            agent_phone: null,
            agent_email: null,
            isAgentOptionsLoading: false,
            tableRows: this.props.data.length

        };

        this.toggleAgentModal = this.toggleAgentModal.bind(this);
        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }

    getOrgCacheKey = (orgId) => {
        if (orgId === undefined || orgId === null || orgId === "") {
            return null;
        }
        return String(orgId);
    }

    getCachedAgentOptions = (orgId) => {
        const key = this.getOrgCacheKey(orgId);
        if (!key) {
            return null;
        }
        return this.agentOptionsByOrgId.get(key) || null;
    }

    fetchAgentOptionsForOrg = async (orgId) => {
        const key = this.getOrgCacheKey(orgId);
        if (!key) {
            return [];
        }
        const fetchedOptions = await this.props.getAgents({ orgid: orgId });
        const nextOptions = Array.isArray(fetchedOptions) ? fetchedOptions : [];
        this.agentOptionsByOrgId.set(key, nextOptions);
        return nextOptions;
    }


    async componentDidMount() {
        if (!this.props.isAuthenticated) {
            return;
        }

        this.setState({ isLoading: false });
    }

    async componentDidUpdate(prevProps) {}

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);
        } catch (e) {
            alert("Error saving");
        }
    }

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            const rowIndex = cellInfo?.row?.index ?? cellInfo?.index;
            if (rowIndex === undefined || rowIndex === null) {
                return;
            }

            data[rowIndex].archived_date = new Date();
            await this.handleDataSave(data[rowIndex]).then((result) => {
                data.splice(rowIndex, 1);
                this.props.updateTableState(data, this.state.dataSet);
                this.props.updateAgencyFields(data);
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async () => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];
        for (var i = 0; i < data.length; i++) {
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }

                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }


        this.props.updateTableState(data, this.state.dataSet);

    }

    handleEditRecord = async (cellInfo, event) => {
        const row = cellInfo?.row?.original || cellInfo?.original;
        const rowIndex = cellInfo?.row?.index ?? cellInfo?.index;
        if (!row || rowIndex === undefined || rowIndex === null) {
            return;
        }

        const cachedAgentOptions = this.getCachedAgentOptions(row.entity_org_id);
        const selectedAgentOption = row.entity_person_id
            ? { value: row.entity_person_id, label: row.agent_name || "" }
            : null;
        const initialAgentOptions = (cachedAgentOptions && cachedAgentOptions.length > 0)
            ? cachedAgentOptions
            : (selectedAgentOption ? [selectedAgentOption] : []);

        this.setState({
            showAgentDialog: true,
            newRecordIndex: rowIndex,
            selectedAgent: { value: row.entity_person_id, label: row.agent_name },
            selectedAgency: { value: row.entity_org_id, label: row.name },
            agency_name: row.name,
            entity_link_id: row.entity_link_id,
            entity_org_id: row.entity_org_id,
            agency_phone: (row.phone_ext || "") + " " + (row.phone_no || " "),
            agency_phone_ext: row.phone_ext,
            agency_phone_no: row.phone_no,
            agency_suburb: row.mail_suburb,
            agency_state: row.mail_state,
            agency_postcode: row.mail_code,
            entity_person_id: row.entity_person_id,
            agent_phone: row.agent_phone,
            agent_email: row.agent_email,
            agentOptions: initialAgentOptions,
            isAgentOptionsLoading: !cachedAgentOptions,
        });

        if (cachedAgentOptions) {
            return;
        }

        try {
            const agentOptions = await this.fetchAgentOptionsForOrg(row.entity_org_id);
            this.setState({ agentOptions: agentOptions || [], isAgentOptionsLoading: false });
        } catch (error) {
            console.error("Failed to load agents", error);
            this.setState({ agentOptions: [], isAgentOptionsLoading: false });
        }
    }

    addRecord = async event => {
        let data = [...this.props.data];

        data.push({

            entity_org_id: null,
            entity_person_id: null,
            sale_id: this.props.sale_id ? this.props.sale_id : null,
            lease_id: this.props.lease_id ? this.props.lease_id : null,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true
        });

        this.setState({
            showAgentDialog: true,
            newRecordIndex: data.length - 1,
            isAgentOptionsLoading: false,
        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    addAnotherRecord = async event => {
        let data = [...this.props.data];

        data.push({

            entity_org_id: null,
            entity_person_id: null,
            sale_id: this.props.sale_id ? this.props.sale_id : null,
            lease_id: this.props.lease_id ? this.props.lease_id : null,
            name: null,
            phone_no: "",
            phone_ext: "",
            mail_suburb: "",
            mail_state: "",
            mail_code: "",
            agent_name: "",
            agent_phone: "",
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true
        });

        this.setState({
            selectedAgency: { value: null, label: null },
            selectedAgent: { value: null, label: null },
            name: null,
            phone_no: "",
            phone_ext: "",
            agency_suburb: "",
            agency_state: "",
            agency_postcode: "",
            agency_phone: "",
            agency_email: "",
            agentOptions: [],
            isAgentOptionsLoading: false,

            agent_name: "",
            agent_phone: "",
            agent_email: "",
            newRecordIndex: data.length - 1
        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    addContactRecord = async event => {
        let data = [...this.props.data];

        data.push({
            entity_org_id: this.state.entity_org_id,
            entity_person_id: null,
            value: this.state.entity_org_id,
            label: this.state.agency_name,
            sale_id: this.props.sale_id ? this.props.sale_id : null,
            lease_id: this.props.lease_id ? this.props.lease_id : null,
            name: this.state.agency_name,
            phone_no: this.state.agency_phone_no,
            phone_ext: this.state.agency_phone_ext,
            mail_suburb: this.state.agency_suburb,
            mail_state: this.state.agency_state,
            mail_code: this.state.agency_postcode,
            agent_name: null,
            agent_phone: null,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true
        });

        this.setState({
            entity_person_id: null,
            agent_phone: "",
            agent_email: "",
            isAgentOptionsLoading: false,
            newRecordIndex: data.length - 1,
            selectedAgent: { label: null, value: null }
        });
        this.props.updateTableState(data, this.state.dataSet);
    }



    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

            case "number":
                return (
                    <input
                        onChange={this.handleInputChange.bind(null, cellInfo)}
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        type="number"
                        className="no-border form-control"
                        value={cellValue}

                    />
                );

            default:
                if (cellInfo.column.id.indexOf("date") >= 0) {
                    return (
                        <DatePicker
                            selected={new Date(cellValue)}
                            onChange={this.handleDateChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            dateFormat="dd/MM/yyyy"
                        />);
                }
                else if (cellInfo.column.id === "name" && cellValue === "") {
                    return (
                        <Select
                            value={cellValue}
                            onChange={this.handleagencyChange}
                            options={this.props.agencyOptions}

                        />);
                }
                else {
                    return (
                        <input
                            onChange={this.handleInputChange.bind(null, cellInfo)}
                            onBlur={this.handleSave.bind(null, cellInfo)}
                            type="text"
                            className="no-border form-control"
                            value={cellValue}

                        />
                    );
                }

        }
    }




    renderTable(data) {
        const columnHelper = createColumnHelper();
        const columns = [
            columnHelper.accessor("entity_org_id", {
                id: "entity_org_id",
                header: "Agency ID",
                cell: (info) => (
                    <LinkContainer to={`../slmentities/${info.getValue()}`}>
                        <Button variant="link" size="sm" className="p-0 align-baseline">
                            {info.getValue()}
                        </Button>
                    </LinkContainer>
                ),
                size: 90,
            }),
            columnHelper.accessor("name", { id: "name", header: "Agency", size: 160 }),
            columnHelper.accessor("mail_street", { id: "mail_street", header: "Street", size: 180 }),
            columnHelper.accessor("mail_suburb", { id: "mail_suburb", header: "Suburb", size: 120 }),
            columnHelper.accessor("mail_state", { id: "mail_state", header: "State", size: 80 }),
            columnHelper.accessor("mail_code", { id: "mail_code", header: "Postcode", size: 90 }),
            columnHelper.accessor("phone_ext", { id: "phone_ext", header: "Phone Ext", size: 90 }),
            columnHelper.accessor("phone_no", { id: "phone_no", header: "Phone No", size: 120 }),
            columnHelper.accessor("email", { id: "email", header: "Email", size: 170 }),
            columnHelper.accessor("web", { id: "web", header: "Web", size: 140 }),
            columnHelper.accessor("notes", { id: "notes", header: "Notes", size: 180 }),
            columnHelper.display({
                id: "actions",
                header: "",
                size: 90,
                cell: (info) => (
                    <Button type="button" variant="danger" size="sm" onClick={(event) => this.handleDeleteRecord(info, event)}>
                        Delete
                    </Button>
                ),
            }),
        ];

        if (!data) {
            return null
        }
        else {
            return (
                <GenericTable
                    columns={columns}
                    data={data}
                    pageSize={PAGE_SIZES.slmAgentAgencySection}
                    enablePagination={true}
                    hasHeaderSorting={false}
                    enforceMinRowsHeight={false}
                    section="slm-entity-link-list"
                    elementIds={this.tableElementIds}
                />
            )
        }

    }




    // Flush controlled Select menu closed before unmounting to prevent portaled-Select onChange race
    handleModalHide = () => {
        this.setState({ agencyMenuIsOpen: false }, () => this.toggleAgentModal());
    }

    toggleAgentModal = async () => {
        const normalizedData = normalizeEntityLinkTableData(this.props.data);

        this.setState(state => ({
            showAgentDialog: !this.state.showAgentDialog,
            agencySearchString: "",
            agencyInterstateFlag: true,
            selectedAgency: null,
            selectedAgent: null,
            agencyMenuIsOpen: false,
            entity_org_id: null,
            agency_phone: "",
            agency_suburb: "",
            agency_state: "",
            agency_postcode: "",
            entity_person_id: null,
            agent_phone: "",
            agent_email: "",
            agentOptions: [],
            isAgentOptionsLoading: false,
        }));
        this.setState({ tableRows: Math.max(5, normalizedData.length) });
        this.props.updateTableState(normalizedData, this.state.dataSet);
        this.props.updateAgencyFields(normalizedData);


    }

    handleAgencySearch = async () => {
        try {
            // Keep `state` as a string for API query params. Use empty string when interstate search is enabled.
            let state = "";
            if (!this.state.agencyInterstateFlag) {
                state = this.props.state_code || "";
            }
            const agencyOptions = await this.props.getAgencies({ agencyname: this.state.agencySearchString, state });
            this.setState({ agencyMenuIsOpen: true, agencyOptions: agencyOptions });
        }
        catch {
            alert("Error loading proposals");
        }
    }

    handleEnterOnAgencySearch = (e) => {
        if (e.keyCode === 13) {
            this.handleAgencySearch();

        }
    }

    handleFormInputChange = event => {
        this.setState({ [event.target.id]: event.target.value });

    }

    handleCheckBoxChange = event => {

        let name = event.target.name
        this.setState({
            [name]: event.target.checked
        })
    }

    handleAgencyChange = async (selectedAgency) => {

        let data = [...this.props.data];
        data[this.state.newRecordIndex].modified = true;

        if (selectedAgency) {
            const cachedAgentOptions = this.getCachedAgentOptions(selectedAgency.value);
            this.setState({
                agencyMenuIsOpen: false
                , selectedAgency: selectedAgency
                , agentOptions: cachedAgentOptions || []
                , isAgentOptionsLoading: !cachedAgentOptions
                , modified: true
                , selectedAgent: { value: null, label: null }
                , agency_name: selectedAgency.name
                , entity_org_id: selectedAgency.value
                , agency_phone: (selectedAgency.phone_ext || "") + " " + (selectedAgency.phone_no || " ")
                , agency_phone_ext: selectedAgency.phone_ext
                , agency_phone_no: selectedAgency.phone_no
                , agency_suburb: selectedAgency.mail_suburb
                , agency_state: selectedAgency.mail_state
                , agency_postcode: selectedAgency.mail_code
                , entity_person_id: null
                , agent_phone: ""
                , agent_email: ""
            });
            data[this.state.newRecordIndex].entity_org_id = selectedAgency.entity_org_id;
            data[this.state.newRecordIndex].name = selectedAgency.name;
            data[this.state.newRecordIndex].phone_ext = selectedAgency.phone_ext;
            data[this.state.newRecordIndex].phone_no = selectedAgency.phone_no;
            data[this.state.newRecordIndex].mail_suburb = selectedAgency.mail_suburb;
            data[this.state.newRecordIndex].mail_state = selectedAgency.mail_state;
            data[this.state.newRecordIndex].mail_code = selectedAgency.mail_code;
            data[this.state.newRecordIndex].agent_name = null;
            data[this.state.newRecordIndex].agent_phone = null;

            if (!cachedAgentOptions) {
                try {
                    const agentOptions = await this.fetchAgentOptionsForOrg(selectedAgency.value);
                    this.setState({ agentOptions: agentOptions || [], isAgentOptionsLoading: false });
                } catch (error) {
                    console.error("Failed to load agents", error);
                    this.setState({ agentOptions: [], isAgentOptionsLoading: false });
                }
            }
        }
        else {
            this.setState({
                agencyMenuIsOpen: false
                , selectedAgency: { value: null, label: null }
                , agentOptions: []
                , isAgentOptionsLoading: false
                , modified: true
                , selectedAgent: { value: null, label: null }
                , entity_org_id: null
                , agency_name: null
                , agency_phone: ""
                , agency_phone_ext: null
                , agency_phone_no: null
                , agency_suburb: ""
                , agency_state: ""
                , agency_postcode: ""
                , entity_person_id: null
                , agent_phone: ""
                , agent_email: ""
            });
            data[this.state.newRecordIndex].entity_org_id = null;
            data[this.state.newRecordIndex].name = null;
            data[this.state.newRecordIndex].phone_ext = null;
            data[this.state.newRecordIndex].phone_no = null;
            data[this.state.newRecordIndex].mail_suburb = null;
            data[this.state.newRecordIndex].mail_state = null;
            data[this.state.newRecordIndex].mail_code = null;
            data[this.state.newRecordIndex].agent_name = null;
            data[this.state.newRecordIndex].agent_phone = null;

            ;
        }
        const result = this.props.updateTableState(data, this.state.dataSet);
        if (result) {
            this.handleSave();
        }

    }


    handleAgentChange = async (selectedAgent) => {
        let data = [...this.props.data];
        data[this.state.newRecordIndex].modified = true;
        if (!selectedAgent) {
            this.setState({
                selectedAgent: { value: null, label: null }
                , modified: true
                , entity_person_id: null
                , agent_phone: ""
                , agent_email: ""

            });
            data[this.state.newRecordIndex].entity_person_id = null;
            data[this.state.newRecordIndex].agent_name = null;
            data[this.state.newRecordIndex].agent_phone = null;
        }
        else {
            this.setState({
                selectedAgent: selectedAgent
                , modified: true
                , entity_person_id: selectedAgent.value
                , agent_phone: (selectedAgent.phone_ext || "") + " " + (selectedAgent.phone_no || " ")
                , agent_email: selectedAgent.email

            });
            data[this.state.newRecordIndex].entity_person_id = selectedAgent.entity_person_id;
            data[this.state.newRecordIndex].agent_name = selectedAgent.first_name + " " + selectedAgent.last_name;
            data[this.state.newRecordIndex].agent_phone = (selectedAgent.phone_ext || "") + " " + (selectedAgent.phone_no || " ");
        }
        const result = this.props.updateTableState(data, this.state.dataSet);
        if (result) {
            this.handleSave();
        }
    }




    renderTable2(data) {
        const columnHelper = createColumnHelper();
        const columns = [
            columnHelper.accessor("entity_link_id", {
                id: "entity_link_id",
                header: "Link ID",
                size: 70,
                cell: (info) => (
                    <Button variant="link" size="sm" onClick={(e) => this.handleEditRecord(info, e)}>
                        <div style={{ fontSize: "11px" }}>{info.getValue()}</div>
                    </Button>
                ),
            }),
            columnHelper.accessor("name", {
                id: "name",
                header: "Agency",
                size: 240,
                meta: { wrap: true },
                cell: (info) => (
                    <div style={{ fontSize: "11px", lineHeight: "1.4" }}>
                        <Button variant="link" style={{ whiteSpace: "normal", textAlign: "left", fontSize: "11px", padding: "0" }} size="sm" onClick={(e) => this.handleEditRecord(info, e)}>
                            {info.getValue()}
                        </Button>
                        <br />p: {info.row.original.phone}
                        <br />e: {info.row.original.email}
                        <br />i: {info.row.original.web}
                    </div>
                ),
            }),
            columnHelper.accessor("agent_name", {
                id: "agent_name",
                header: "Contact Name",
                size: 160,
                meta: { wrap: true },
                cell: (info) => (
                    <div style={{ fontSize: "11px", lineHeight: "1.4" }}>
                        {info.getValue()}<br />t: {info.row.original.agent_phone}
                    </div>
                ),
            }),
            columnHelper.display({
                id: "actions",
                header: "",
                size: 90,
                cell: (info) => <Button type="button" variant="danger" size="sm" onClick={(e) => this.handleDeleteRecord(info, e)}>Remove</Button>,
            }),
        ];

        if (!data) {
            return null
        }
        else {
            return (
                <div>
                    <SLMAgencyModal
                        show={this.state.showAgentDialog}
                        onHide={this.handleModalHide}
                        agencySearchString={this.state.agencySearchString || ""}
                        onAgencySearchStringChange={(e) => this.setState({ agencySearchString: e.target.value })}
                        onAgencySearchKeyDown={this.handleEnterOnAgencySearch}
                        onAgencySearch={this.handleAgencySearch}
                        agencyInterstateFlag={Boolean(this.state.agencyInterstateFlag)}
                        onAgencyInterstateFlagChange={this.handleCheckBoxChange}
                        createAgencyHref="/slmentities/new"
                        editAgencyHref={this.state.entity_org_id ? `/slmentities/${this.state.entity_org_id}` : null}
                        showAddAnotherAgencyLink={Boolean(this.state.entity_org_id)}
                        onAddAnotherAgencyLink={this.addAnotherRecord}
                        selectedAgency={this.state.selectedAgency}
                        onAgencyChange={this.handleAgencyChange}
                        agencyOptions={this.state.agencyOptions}
                        agencyMenuIsOpen={this.state.agencyMenuIsOpen}
                        agencyPhone={this.state.agency_phone || ""}
                        agencyLocale={`${this.state.agency_suburb || ""} ${(this.state.agency_state || "").trim()} ${(this.state.agency_postcode || "").trim()}`.trim()}
                        selectedAgent={this.state.selectedAgent}
                        onAgentChange={this.handleAgentChange}
                        agentOptions={this.state.agentOptions}
                        isAgentOptionsLoading={Boolean(this.state.isAgentOptionsLoading)}
                        agentPhone={this.state.agent_phone || ""}
                        agentEmail={this.state.agent_email || ""}
                        showAddAnotherContact={Boolean(this.state.entity_person_id)}
                        onAddAnotherContact={this.addContactRecord}
                    />
                    <GenericTable
                        columns={columns}
                        data={data}
                        pageSize={PAGE_SIZES.slmAgentAgencySection}
                        enablePagination={data.length > PAGE_SIZES.slmAgentAgencySection}
                        paginationMode="minimal"
                        hasHeaderSorting={true}
                        section="slm-entity-link-list"
                        elementIds={this.tableElementIds}
                    />
                </div>
            )
        }

    }

    renderList(data) {
        return [{}].concat(data).map(
            (d, i) =>
                i !== 0
                    ?
                    <ListGroup.Item key={i} as="a" header={d.name}>
                        {d.name}
                    </ListGroup.Item>
                    : ""
        );
    }




    renderComponent() {
        return (
            <div className="agencies" id={this.createId("container")}>

                <Row className="show-Container g-2 mb-2">
                    <Col xs={12} className="text-right" >
                        <a target="_blank" rel="noopener noreferrer" href={`/slmentities/new`}><Button id={this.createId("action", "create-agency", "button")} variant="primary" type="button" className="slm-compact-action-btn" size="m" >Create New Agency</Button></a>{" "}
                        <Button id={this.createId("action", "add-link", "button")} variant="primary" className="slm-compact-action-btn" size="m" onClick={this.addRecord}>Add New Link</Button>

                    </Col>
                </Row>

                <Row className="show-Container g-2">
                    <Col xs={12}>
                        {!this.state.isLoading ? this.props.controlType === "table2" ? this.renderTable2(this.props.data) : this.renderTable(this.props.data) : null}
                    </Col>
                </Row>


            </div>
        );
    }
    render() {
        if (!this.props.data) {
            return null
        }
        else {
            return (

                <div className="EntityLinkSection">
                    {this.props.isAuthenticated ? this.renderComponent() : null}
                </div>
            );
        }
    }
}
